// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IOrganizationPropertiesStateConfigRequestDto
 */
export interface IOrganizationPropertiesStateConfigRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPropertiesStateConfigRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPropertiesStateConfigRequestDto
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: IFieldStateType; }}
     * @memberof IOrganizationPropertiesStateConfigRequestDto
     */
    properties: { [key: string]: IFieldStateType; };
    /**
     * 
     * @type {{ [key: string]: IFieldStateType; }}
     * @memberof IOrganizationPropertiesStateConfigRequestDto
     */
    overridable_properties: { [key: string]: IFieldStateType; };
}

/**
 * Check if a given object implements the IOrganizationPropertiesStateConfigRequestDto interface.
 */
export function instanceOfIOrganizationPropertiesStateConfigRequestDto(value: object): value is IOrganizationPropertiesStateConfigRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('properties' in value) || value['properties'] === undefined) return false;
    if (!('overridable_properties' in value) || value['overridable_properties'] === undefined) return false;
    return true;
}

export function IOrganizationPropertiesStateConfigRequestDtoFromJSON(json: any): IOrganizationPropertiesStateConfigRequestDto {
    return IOrganizationPropertiesStateConfigRequestDtoFromJSONTyped(json, false);
}

export function IOrganizationPropertiesStateConfigRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationPropertiesStateConfigRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'properties': (mapValues(json['properties'], IFieldStateTypeFromJSON)),
        'overridable_properties': (mapValues(json['overridable_properties'], IFieldStateTypeFromJSON)),
    };
}

export function IOrganizationPropertiesStateConfigRequestDtoToJSON(json: any): IOrganizationPropertiesStateConfigRequestDto {
    return IOrganizationPropertiesStateConfigRequestDtoToJSONTyped(json, false);
}

export function IOrganizationPropertiesStateConfigRequestDtoToJSONTyped(value?: IOrganizationPropertiesStateConfigRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'properties': (mapValues(value['properties'], IFieldStateTypeToJSON)),
        'overridable_properties': (mapValues(value['overridable_properties'], IFieldStateTypeToJSON)),
    };
}

